<div class="upgrade-tag">
  <mat-icon class="upgrade-icon" [class.material-icons-outlined]="true">diamond</mat-icon>

  <ng-content></ng-content>
</div>
